import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LOCALE_CA from "./locales/ca.json";
import LOCALE_CH from "./locales/ch.json";
import LOCALE_DE from "./locales/de.json";
import LOCALE_EN from "./locales/en.json";
import LOCALE_EE from "./locales/ee.json";
import LOCALE_ES from "./locales/es.json";
import LOCALE_FI from "./locales/fi.json";
import LOCALE_FR from "./locales/fr.json";
import LOCALE_IT from "./locales/it.json";
import LOCALE_JA from "./locales/ja.json";
import LOCALE_NL from "./locales/nl.json";
import LOCALE_NO from "./locales/no.json";
import LOCALE_RO from "./locales/ro.json";
import LOCALE_RU from "./locales/ru.json";
import LOCALE_SE from "./locales/sv.json";

const resources = {
  ca: {
    translation: LOCALE_CA,
  },
  ch: {
    translation: LOCALE_CH,
  },
  de: {
    translation: LOCALE_DE,
  },
  ee: {
    translation: LOCALE_EE,
  },
  en: {
    translation: LOCALE_EN,
  },
  es: {
    translation: LOCALE_ES,
  },
  fi: {
    translation: LOCALE_FI,
  },
  fr: {
    translation: LOCALE_FR,
  },
  it: {
    translation: LOCALE_IT,
  },
  ja: {
    translation: LOCALE_JA,
  },
  nl: {
    translation: LOCALE_NL,
  },
  no: {
    translation: LOCALE_NO,
  },
  ro: {
    translation: LOCALE_RO,
  },
  ru: {
    translation: LOCALE_RU,
  },
  se: {
    translation: LOCALE_SE,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: process.env.REACT_APP_DEFAULT_LOCALE,
    supportedLngs: [
      "ca",
      "ch",
      "de",
      "ee",
      "en",
      "es",
      "fi",
      "fr",
      "it",
      "ja",
      "nl",
      "no",
      "ro",
      "ru",
      "se",
    ],
    fallbackLng: "en",
    load: "all",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    returnNull: false,
    returnEmptyString: false,
  });

export default i18n;
